import React from 'react';
import { Card } from 'antd';
import { TagCloud } from 'react-tagcloud';

const InvestmentBanner = () => {
  // 标签云数据
  const tags = [
    { value: "投资入门", count: 30 },
    { value: "财报阅读", count: 20 },
    { value: "公司·行业研究", count: 45 },
    { value: "免费财务数据", count: 25 },
    { value: "工具和信息源", count: 35 },
    { value: "投资大师·基金经理", count: 40 },
    { value: "企业·企业家传记", count: 28 }
  ];

  // 标签云配置
  const options = {
    radius: 150,
    maxFontSize: 26,
    minFontSize: 12,
    colorOptions: {
      background: "linear-gradient(135deg, #6633ff, #3366ff)",
      text: "#ffffff"
    },
    shuffle: true,
    padding: 10,
    spiral: "archimedean",
    direction: 1,
    wheelZoom: false
  };

  // 自定义标签渲染函数
  const renderTag = (tag, size, color) => (
    <a
      key={tag.value}
      href="https://acnz5u8jm08w.feishu.cn/wiki/XZXFw3l2WiqDb0kNzdhcOyqUnLb"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontSize: `${size}px`,
        padding: '6px 12px',
        margin: '5px',
        display: 'inline-block',
        borderRadius: '20px',
        textDecoration: 'none',
        backgroundColor: color.background,
        color: color.text,
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}
      onMouseOver={(e) => {
        e.target.style.transform = 'scale(1.1)';
        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
      }}
      onMouseOut={(e) => {
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = '0 2px 5px rgba(0,0,0,0.1)';
      }}
    >
      {tag.value}
    </a>
  );

  return (
    <div style={{ 
      padding: '50px 20px', 
      background: 'linear-gradient(135deg, #ff0000, #ff9900, #ffff00, #33cc33, #3366ff, #9933ff, #cc00ff)'
    }}>
      <Card 
        className="investment-card"
        style={{ 
          maxWidth: 800, 
          margin: '0 auto', 
          textAlign: 'center',
          padding: '30px',
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          borderRadius: '12px',
          border: 'none',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
        }}
      >
        <h1 style={{ 
          fontSize: '2.0rem', 
          marginBottom: '20px',
          fontWeight: 'bold',
          color: '#333'
        }}>
          <a 
            href="https://acnz5u8jm08w.feishu.cn/wiki/space/7498171445865562113?ccm_open_type=lark_wiki_spaceLink&open_tab_from=wiki_home" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#333',
              textDecoration: 'none',
              transition: 'color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.color = '#6633ff'}
            onMouseOut={(e) => e.target.style.color = '#333'}
          >
            直达『通往价值投资之路』知识库
          </a>
        </h1>
        <p style={{ 
          fontSize: '1.6rem', 
          color: '#666',
          letterSpacing: '2px',
          margin: '0 0 30px 0'
        }}>
          <a 
            href="https://acnz5u8jm08w.feishu.cn/wiki/space/7498171445865562113?ccm_open_type=lark_wiki_spaceLink&open_tab_from=wiki_home" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#666',
              textDecoration: 'none',
              transition: 'color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.color = '#3366ff'}
            onMouseOut={(e) => e.target.style.color = '#666'}
          >
            A WAY TO FINANCIAL FREEDOM · WIKI
          </a>
        </p>
      </Card>
    </div>
  );
};

export default InvestmentBanner;